import { render, staticRenderFns } from "./ActivityListColumn.vue?vue&type=template&id=38182db8&scoped=true&"
import script from "./ActivityListColumn.vue?vue&type=script&lang=js&"
export * from "./ActivityListColumn.vue?vue&type=script&lang=js&"
import style0 from "./ActivityListColumn.vue?vue&type=style&index=0&id=38182db8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38182db8",
  null
  
)

export default component.exports